"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _classnames = _interopRequireDefault(require("classnames"));

var _invert = _interopRequireDefault(require("lodash/invert"));

var _globals = require("@insided/shared/utils/globals");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'cookie-banner'; // For more info:
// https://insidedhq.atlassian.net/wiki/spaces/IM/pages/6422598/Cookie+permission+dialog+setup

exports.cssAnchorName = cssAnchorName;
var PRIVACY_LEVEL_ALL = 3;
var PRIVACY_LEVEL_NONE = 1;
var levels = [1, 2, 3];

// Essential cookies exempt from consent requirements (GDPR Art. 5(3)):
// - login_referer: stores redirect URL for post-login navigation
// - consentCookieName: remembers user's cookie consent preference
var getWhiteListCookieNames = function getWhiteListCookieNames(consentCookieName) {
  return ['login_referer', consentCookieName];
};

var CookieBanner = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CookieBanner, _Component);

  var _super = _createSuper(CookieBanner);

  function CookieBanner() {
    var _this;

    (0, _classCallCheck2.default)(this, CookieBanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isSettingsOpen: false,
      selectedValue: _this.getCookieValue(),
      isCookieSet: typeof _jsCookie.default.get(_this.cookieName()) !== 'undefined'
    });
    return _this;
  }

  (0, _createClass2.default)(CookieBanner, [{
    key: "setCookie",
    value: function setCookie(level) {
      var _config$expires;

      var config = this.props.cookieConfig;
      var levels = (0, _invert.default)(config.mapping);
      var value = levels[level];

      if (config.type === 'json') {
        var _config$field;

        var cookie = _jsCookie.default.get(this.cookieName());

        var parsedCookie = {};

        try {
          parsedCookie = JSON.parse(cookie !== null && cookie !== void 0 ? cookie : '');
        } catch (e) {}

        parsedCookie[(_config$field = config.field) !== null && _config$field !== void 0 ? _config$field : ''] = value;
        value = JSON.stringify(parsedCookie);
      }

      var domain = window.location.hostname.split('.').slice(-2).join('.');
      var whitelist = getWhiteListCookieNames(this.cookieName());
      Object.keys(_jsCookie.default.get()).filter(function (key) {
        return !whitelist.includes(key);
      }).forEach(function (key) {
        _jsCookie.default.remove(key, {
          domain: domain
        });

        _jsCookie.default.remove(key);
      });

      _jsCookie.default.set(this.cookieName(), value, {
        expires: (_config$expires = config.expires) !== null && _config$expires !== void 0 ? _config$expires : 365
      });

      this.setState({
        isSettingsOpen: false,
        isCookieSet: true
      });
    }
  }, {
    key: "getCookieValue",
    value: function getCookieValue() {
      var _config$mapping$parse, _config$field2;

      var cookie = _jsCookie.default.get(this.cookieName());

      var config = this.props.cookieConfig;

      if (config.type !== 'json') {
        return cookie ? config.mapping[cookie] : PRIVACY_LEVEL_NONE;
      }

      var parsedCookie = {};

      try {
        parsedCookie = JSON.parse(cookie !== null && cookie !== void 0 ? cookie : '');
      } catch (e) {}

      return (_config$mapping$parse = config.mapping[parsedCookie[(_config$field2 = config.field) !== null && _config$field2 !== void 0 ? _config$field2 : '']]) !== null && _config$mapping$parse !== void 0 ? _config$mapping$parse : PRIVACY_LEVEL_NONE;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _globals.subscribe)('edit_cookie_settings', function () {
        return _this2.setState({
          isSettingsOpen: true
        });
      });
    }
  }, {
    key: "cookieName",
    value: function cookieName() {
      var _this$props$cookieCon;

      return (_this$props$cookieCon = this.props.cookieConfig.name) !== null && _this$props$cookieCon !== void 0 ? _this$props$cookieCon : 'cookiePrivacyLevel';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      if (typeof window === 'undefined') return null;
      return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
        var _this3$state$isSettin;

        if (!modules.includes('cookiebar') || props.cookieConfig.use_external_modal) return null;
        return (0, _preact.h)("div", null, (0, _preact.h)("div", {
          className: (0, _classnames.default)('cookiebar', 'js-cookiebar', {
            'is-hidden': !_this3.state.isSettingsOpen && _this3.state.isCookieSet
          }),
          style: _this3.state.isSettingsOpen ? {
            top: '0'
          } : {}
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)('container', 'js-cookiebar-short', {
            'is-hidden': (_this3$state$isSettin = _this3.state.isSettingsOpen) !== null && _this3$state$isSettin !== void 0 ? _this3$state$isSettin : _this3.state.isCookieSet
          })
        }, (0, _preact.h)("h3", null, (0, _preact.h)(_phrase.default, {
          m: "Forum",
          p: "cookiepolicy.title"
        })), (0, _preact.h)("p", null, (0, _preact.h)(_phrase.default, {
          m: "Forum",
          p: "cookiepolicy.content",
          count: {
            link: props.termsConditions
          }
        })), (0, _preact.h)("div", null, (0, _preact.h)("button", {
          className: "btn js-cookie-accept",
          onClick: function onClick() {
            return _this3.setCookie(PRIVACY_LEVEL_ALL);
          }
        }, (0, _preact.h)(_phrase.default, {
          p: "cookiepolicy.button"
        })), "\xA0", (0, _preact.h)("button", {
          className: (0, _classnames.default)('btn', 'btn-secondary', 'js-cookie-deny'),
          onClick: function onClick() {
            return _this3.setCookie(PRIVACY_LEVEL_NONE);
          }
        }, (0, _preact.h)(_phrase.default, {
          p: "cookiepolicy.button.deny"
        }))), (0, _preact.h)("a", {
          className: "cookiebar--info js-cookie-info",
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            return _this3.setState({
              isSettingsOpen: true
            });
          },
          onKeyDown: function onKeyDown(event) {
            if (event.key === 'Enter' || event.key === 'Space') {
              _this3.setState({
                isSettingsOpen: true
              });
            }
          }
        }, (0, _preact.h)(_phrase.default, {
          p: "cookiepolicy.link"
        }))), (0, _preact.h)("div", {
          className: (0, _classnames.default)('js-cookiemodal', 'cookiemodal-wrapper', {
            'is-hidden': !_this3.state.isSettingsOpen
          })
        }, (0, _preact.h)("div", {
          className: "js-cookiemodal-close cookiemodal-close",
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            return _this3.setState({
              isSettingsOpen: false
            });
          },
          onKeyDown: function onKeyDown(event) {
            if (event.key === 'Enter' || event.key === 'Space') {
              _this3.setState({
                isSettingsOpen: false
              });
            }
          }
        }, "\xD7"), (0, _preact.h)("h3", null, (0, _preact.h)(_phrase.default, {
          p: "cookiepolicy.modal.title"
        })), (0, _preact.h)("br", null), (0, _preact.h)("p", null, (0, _preact.h)(_phrase.default, {
          p: "cookiepolicy.modal.content",
          count: {
            link: props.termsConditions
          }
        })), (0, _preact.h)("br", null), levels.map(function (level) {
          var id = "privacy_level_".concat(level);
          return (0, _preact.h)("div", {
            key: level
          }, (0, _preact.h)("div", {
            className: "fancyselect"
          }, (0, _preact.h)("input", {
            className: "js-level-radio",
            id: id,
            name: "privacyLevel",
            value: level,
            type: "radio",
            checked: level === _this3.state.selectedValue,
            autoComplete: "off",
            onClick: function onClick() {
              return _this3.setState({
                selectedValue: level
              });
            }
          }), (0, _preact.h)("label", {
            htmlFor: id
          }, (0, _preact.h)(_phrase.default, {
            p: "cookiepolicy.modal.level".concat(level)
          }))), (0, _preact.h)("br", null));
        }), (0, _preact.h)("div", null, (0, _preact.h)("button", {
          className: "btn js-select-level",
          onClick: function onClick() {
            return _this3.setCookie(_this3.state.selectedValue);
          }
        }, (0, _preact.h)(_phrase.default, {
          p: "cookiepolicy.button"
        }))))));
      });
    }
  }]);
  return CookieBanner;
}(_preact.Component);

var _default = CookieBanner;
exports.default = _default;